@media (max-width: 575.98px) {
  .ion-hide-sm-down {
    display: none !important;
  }
}


:host {
  display: block;
  height: 80px;
  padding: 0 20px;
  color: #666;
  font-size: 0.8em;
  white-space: nowrap;
  width: 100%;
}

.timeline-container {
  position: relative;
  width: 100%;
}

.timeline-bar {
  position: absolute;
  height: 2px;
  top: 32px;
  width: 100%;
  background-color: grey;
}

.timeline-bar .bar{
  position: absolute;
  height: 12px;
  top: -5px;
}
.timeline-bar .bar.clickable {
  cursor: pointer;
}
.timeline-bar .bar.clickable:hover{
  background-color: #666;
}
.timeline-bar .bar div {
  position: absolute;
  top: 5px;
  height: 2px;
}
.timeline-bar .bar .complete{
  background-color: #388e3c;
}
.timeline-bar .bar .overdue{
  background-color: red;
}
.timeline-bar .bar .current{
  background-color: var(--ion-color-primary, gold);
}
.timeline-bar .bar .future{
  background-color: grey;
}

.timeline-bar small {
  font-size: 0.8em;
}

.timeline-marker {
  position: absolute;
}

.timeline-bubble, .timeline-marker {
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  transform: translateX(-50%);
}

.timeline-bubble {
  top: 14px; /* space so the marker can sit above it */
  cursor: pointer;
}

.timeline-marker .vertical-bar {
  width: 2px;
  height: 22px;
  background: grey;
}

.rounded-bg {
  background: grey;
  padding: 0px 4px;
  border-radius: 8px;
  font-size: 0.8em;
  color: black
}

.timeline-bubble.circle-stack {
  position: relative;
  width: 36px;
  height: 36px;
}

.timeline-bubble .circle{
  position: relative;
  width: 34px;
  height: 34px;
  border-width: 2px;
  border-style: solid;
  border-radius: 50%;
  background-size: cover;
  background-color: grey;

  /* position the initials */
  display: flex;
  align-items: center;
  justify-content: center;
  color: black;
}

.shadow-left {
  box-shadow: -3px 0px 3px rgba(0, 0, 0, 0.8);
}

.timeline-bubble .check-complete {
  position: absolute;
  top: 0;
  right: -4px;
  color: #388e3c;
  font-size: 18px;
  border-radius: 50%;
  background-color: black;
}

.timeline-bubble .label {
  text-align: center;
  font-size: 0.8em;
}



.complete {
  border-color: #388e3c;
}
.overdue {
  border-color: red;
}
.current {
  border-color: var(--ion-color-primary, gold);
}
.future {
  border-color: grey;
}

